import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';

import { provideHttpClient, ɵHTTP_ROOT_INTERCEPTOR_FNS } from '@angular/common/http';
import { provideClientHydration } from '@angular/platform-browser';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { routes } from './app.routes';
import { authInterceptor } from './interceptors/auth.interceptor';

// function initializeABTestService(statsigService: StatsIGService) {
//     return (): Promise<void> => {
//       return statsigService.initializeStatsig();
//     };
//   }

export const appConfig: ApplicationConfig = {
    providers: [
        provideZoneChangeDetection({ eventCoalescing: true }), 
        provideRouter(routes), 
        provideClientHydration(),
        provideAnimationsAsync(),
        provideHttpClient(),
        {
            provide: ɵHTTP_ROOT_INTERCEPTOR_FNS,
            useValue: authInterceptor,
            multi: true
        },
        // {
        //     provide: APP_INITIALIZER,
        //     useFactory: initializeABTestService,
        //     deps: [StatsIGService],
        //     multi: true,
        // },
    ]
};